"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _themeProvider = require("@mmc/theme-provider");
var _modal = _interopRequireDefault(require("./modal.css"));
var Modal = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(Modal, _React$PureComponent);
  function Modal() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  Modal.allowParentScroll = function allowParentScroll(allow) {
    if (allow === void 0) {
      allow = false;
    }
    if (allow) {
      (0, _themeProvider.disableBodyScroll)();
    } else {
      (0, _themeProvider.enableBodyScroll)();
    }
  };
  var _proto = Modal.prototype;
  _proto.render = function render() {
    var _clsx;
    var _this$props = this.props,
      actions = _this$props.actions,
      testID = _this$props['data-testid'],
      children = _this$props.children,
      isOpen = _this$props.isOpen,
      title = _this$props.title;
    if (!isOpen) {
      Modal.allowParentScroll(false);
      return null;
    }
    Modal.allowParentScroll(true);
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": testID,
      className: (0, _clsx2["default"])(_modal["default"].container, (_clsx = {}, _clsx[_modal["default"].isOpen] = isOpen, _clsx))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _modal["default"].inner
    }, title && /*#__PURE__*/_react["default"].createElement("p", {
      className: _modal["default"].title
    }, title), children && /*#__PURE__*/_react["default"].createElement("div", {
      className: _modal["default"].content
    }, children), actions && /*#__PURE__*/_react["default"].createElement("div", null, actions)));
  };
  return Modal;
}(_react["default"].PureComponent);
exports["default"] = Modal;
Modal.displayName = 'Modal';
Modal.defaultProps = {
  isOpen: false
};